<template>
  <el-container style="height:100%">
    <el-header>
      <LayoutHeader></LayoutHeader>
    </el-header>
    <el-container>
      <el-aside width="200px">
        <LayoutAside></LayoutAside>
      </el-aside>
      <el-container>
        <el-main>
          <router-view />
        </el-main>
        <el-footer height="20px">
          <LayoutFooter></LayoutFooter>
        </el-footer>
      </el-container>
    </el-container>
  </el-container>

</template>

<script>
  import LayoutHeader from "@/components/Main/LayoutHeader";
  import LayoutAside from "@/components/Main/LayoutAside";
  import LayoutFooter from "@/components/Main/LayoutFooter";
  export default {
    name: "Main",
    components: {
      LayoutHeader,
      LayoutAside,
      LayoutFooter
    },
    data() {
      return {

      }
    },
    mounted() {
      this.$router.push({
        component: "Chart"
      });
    }
  };

</script>

<style scoped>
  header {
    background-color: #7abbec;
  }

  main {
    background-color: #fcfdf8;
    padding: 15px 15px 0 15px;
    height: calc(100% - 60px - 20px);
  }

  footer {
    background-color: #fcfdf8;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Main.vue